import apiBase from "@/api/unversioned/apiBase";
import { DeviationDataRequestPayload } from "@/views/CarrierPerformanceView/types";
import { type AxiosRequestConfig } from "axios";

const baseURL = `${import.meta.env.VITE_API_BASE_URL}/carrier-performance/query`;

const deviationQuery = (
  endpoint: string,
  payload: DeviationDataRequestPayload,
  requestBody: any,
  config?: AxiosRequestConfig
) => {
  const queryString = new URLSearchParams(
    Object.entries(payload)
      .filter(([, value]) => value !== undefined && value !== null)
      .flatMap(([key, value]) => (Array.isArray(value) ? value.map((v) => [key, String(v)]) : [[key, String(value)]]))
  ).toString();

  const path = "reliabilityCalculationBasis" in payload ? "reliability" : "transit";
  return apiBase("post", `${baseURL}/${path}/${endpoint}?${queryString}`, config, requestBody);
};

const deviation = (payload: DeviationDataRequestPayload, requestBody: any, config?: AxiosRequestConfig) =>
  deviationQuery("deviation", payload, requestBody, config);

export { deviation };
